// Dependencies
import React from 'react';

import { Box } from '@nerdwallet/currency';

import Cta from './cta';

import styles from './card-cta.module.less';

type CardCtaProps = {
  children: React.ReactNode;
  iconName: string;
  trackingId: string;
  subtitle?: string;
  title: string;
};

const CardCta: React.FC<CardCtaProps> = ({ children, ...otherProps }) => (
  <Box className={styles.cardCta}>
    <Cta {...otherProps}>{children}</Cta>
  </Box>
);

CardCta.defaultProps = {
  subtitle: null,
};

export default CardCta;
